import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createTask = (task) => {
    return vdkEmHappinessPortalApi.post('/tasks/create', task);
};
const updateTask = (task) => {
    return vdkEmHappinessPortalApi.put(`/tasks/update`, task);
};
const getAllTasks = () => {
    return vdkEmHappinessPortalApi.get('/tasks/get-all');
};
const getAllTaskAssignedToUser = () => {
    return vdkEmHappinessPortalApi.get('/tasks/get-all-assigned-tasks');
};
const getTasksGroupedByStatus = (query = {}) => {
    return vdkEmHappinessPortalApi.post('/tasks/grouped-by-status', query);
};
const getTaskById = (taskId) => {
    return vdkEmHappinessPortalApi.get(`/tasks/${taskId}`);
};
const deleteTask = (taskId) => {
    return vdkEmHappinessPortalApi.delete(`/tasks/${taskId}`);
};
const getTasksByEventIdGroupedByStatus = (eventId, query = {}) => {
    return vdkEmHappinessPortalApi.post(`/tasks/grouped-by-status/event/${eventId}`, query);
};
const getAllActivityTasks = (personId) => {
    return vdkEmHappinessPortalApi.get(`/tasks/get-all-activity-task/person/${personId}`);
};
const taskAPI = {
    createTask,
    updateTask,
    getAllTasks,
    getTaskById,
    deleteTask,
    getTasksGroupedByStatus,
    getTasksByEventIdGroupedByStatus,
    getAllTaskAssignedToUser,
    getAllActivityTasks
};
export default taskAPI;
